import { render, staticRenderFns } from "./GiziSeksiChecklist.vue?vue&type=template&id=00272730&scoped=true&"
import script from "./GiziSeksiChecklist.vue?vue&type=script&lang=ts&"
export * from "./GiziSeksiChecklist.vue?vue&type=script&lang=ts&"
import style0 from "./GiziSeksiChecklist.vue?vue&type=style&index=0&id=00272730&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00272730",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VBtnToggle,VSimpleTable,VTextField,VTextarea})
